<template>
  <div class="imageUpload">

    <div class="group">
      <label>
        <span v-if="title">{{ title }}</span>
        <span v-if="!title">
          <template v-if="video">{{$t("branch.download_video")}}</template>
          <template v-if="document">{{$t("branch.download_document")}}</template>
          <template v-else>{{ $t("branch.download_image") }} ({{formattedSupportedFormats}})</template>
          <template v-if="maxSizeInMb">&nbsp;({{$t('max_size')}} {{maxFileSizeInMb}}{{ $t('mb') }})</template>
        </span>
        <Tooltip v-if="!video" :text="$t(tooltip)"></Tooltip>
      </label>
      <div class="input-group">
        <input class="uploadImageInput" :id="identifier" :ref="identifier" type="file" :accept="supportedFormats.join(', ')" @change="uploadedImage($event)">
        <input class="file-upload" type="text" v-model="imageName" @click="$refs[identifier].click()" readonly>
        <div class="buttons">
          <button class="btnDownload btn btn-secondary" @click="$refs[identifier].click()">{{$t("branch.download")}}</button>
          <button class="btnDelete btn btn-secondary" @click="deleteImage">
            <svgicon src="icon/delete.svg" height="15" width="15"></svgicon>
          </button>
        </div>
      </div>
    </div>
    <div class="group" v-if="!video && !document">
      <div class="image-preview" :style="{backgroundImage: imagePath(image), height: height}">
      </div>
    </div>

  </div>
</template>

<script>
  import Tooltip from "@/components/tools/Tooltip";

  export default {
    name: "imageUpload",

    props: {
      object: Object|Number,
      video: Boolean,
      document: Boolean,
      title: String,
      formats: Array,
      identifier: String,
      maxSizeInMb: Number,// in MB
      previewHeight: Number,
      tooltip: {
        type: String,
        default: 'branch.download_tooltip'
      }
    },

    components: { Tooltip },

    data() {
      return {
        image: null,
        imageName: ""
      }
    },

    watch: {
      object: {
        deep: true,
        handler: function() {
          this.image = this.object || { url: "" };
        }
      }
    },

    mounted() {
      this.image = this.object || { url: "" };
    },

    computed: {
      height() {
        if (this.previewHeight) {
          return this.previewHeight + "px";
        }
      },
      supportedFormats() {
        let formats = ["image/png", "image/jpeg", "image/gif"];
        if (this.video) {
          formats = ["video/mp4"];
        } else if (this.document) {
          formats = ["application/pdf"]
        } else if (this.formats && this.formats.length > 0) {
          formats = this.formats;
        }
        return formats;
      },
      formattedSupportedFormats() {
        return this.supportedFormats.join(", ").replaceAll("image/","");
      },
      maxFileSize() {
        if (this.maxSizeInMb) {
          return this.maxSizeInMb * window.B_IN_MB;
        }
        return window.MAX_FILE_SIZE;
      },
      maxFileSizeInMb() {
        return (this.maxFileSize / window.B_IN_MB);
      }
    },

    methods: {
      deleteImage() {
        this.image = { url: "" };
        this.imageName = "";
        this.$emit("changed", { url: "", deleted: true });
      },
      imagePath(image) {
        if (image && image.url) {
          let path = image.url.startsWith("data:") ? image.url : Parameters.urlFileServer + image.url;
          return "url('" + path + "')";
        } else {
          return "url('/img/photo-placeholder.png')";
        }
      },
      async uploadedImage(e) {
        let file = e.target.files[0];

        console.log(file.type);

        if (!this.video && !this.document && !this.supportedFormats.includes(file.type)) {
          if (this.formats && this.formats.length > 0) {
            showAffirmation(this.$t("error.title"), this.$t('error.file_type_image_custom').replace("{FORMAT}", this.formattedSupportedFormats));
          } else {
            this.$modal.show("file-type-image-error");
          }
        } else if (this.video && !this.supportedFormats.includes(file.type)) {
          this.$modal.show("file-type-video-error");
        } else if (this.document && !this.supportedFormats.includes(file.type)) {
          this.$modal.show("file-type-document-error");
        } else if (file.size > (this.maxFileSize)) {
          showAffirmation(this.$t("error.title"), this.$t("error.file_size_custom").replace("{SIZE}", (this.maxFileSize / window.B_IN_MB)));
        } else {
          this.imageName = e.target.value.split('\\').pop();
          let url = await this.onFileReader(file);
          this.image = {
            url: url,
            base64: this.getBase64Data(url),
            name: this.imageName
          }
          this.$emit("changed", this.image);
        }
      },

      onFileReader(file) {
        return new Promise((resolve, reject) => {
          let fileReader = new FileReader();
          fileReader.onload = async () => {
            resolve(fileReader.result);
          };
          fileReader.readAsDataURL(file);
        });
      },

      getBase64Data(url) {
        return url.replace(/^data:image\/(png|jpeg|gif);base64,/, "").replace(/^data:video\/mp4;base64,/, "").replace("data:application/pdf;base64,","");
      },
    }
  }
</script>

<style lang="scss" scoped>
  .uploadImageInput {
    position: absolute;
    left: -999999px;
  }
  .input-group input {
    width: 1px;
    margin-left: 0 !important;
  }
  .image-preview {
    display: flex;
    height: 260px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-color: #f9f9f9;
  }
  .btnDelete {
    margin-left: 10px;
    display: flex;
    fill: white;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .buttons {
    display: flex;
  }

  @media screen and (max-width: 720px) {
    .btnDownload {
      width: 85%;
      display: inline-block;
    }
    .btnDelete {
      margin-right: 0;
    }
    .input-group input {
      width: 100%;
    }
  }
</style>
